<template>
  <div class="class">
    <table :id="_class.category" :class="['class__description__' + _class.category]">
      <tr>
        <td class="class__description">
          <span :class="['class__description__title', 'class__description__title__' + _class.category]">{{ _class.category | classNameFormatter }}</span>
          <vue-markdown :source="_class.description" :class="['class__description__text', 'class__description__text__' + _class.category]"/>
        </td>
      </tr>
    </table>

    <div>
      <div :class="['class__information', 'class__information__' + _class.category]">
        <vue-markdown :source="_class.informations"/>
      </div>

      <ul
          class="class__structure"
          v-if="_class.membersOnly === true || _class.overchargeNonResident === true"
      >
        <li><span class="subtitle">À noter</span> :</li>
        <li v-if="_class.priceMember">
          <span class="subtitle">Coût : </span>
          Membre du club des ornithologues : {{ _class.priceMember | money }}
          <template v-if="_class.priceMemberMinor">
            (jeunes 17 ans et moins : {{ _class.priceMemberMinor | money }})
          </template>
        </li>
        <li v-if="_class.membersOnly === true">
          les participants seront des membres du COQ. Un non-membre qui désire
          s’inscrire au cours doit d’abord devenir membre du Club.
        </li>
        <li
            style="margin-top: 20px;"
            v-if="_class.overchargeNonResident === true"
        >
          <b style="vertical-align: top;">Non-résidents de la ville de Québec :&nbsp;</b>
          <ul class="structure">
            <li>
              {{ _class.surplusNonResident.priceRegular | money }} en sus des
              frais réguliers.
            </li>
            <li v-if="_class.surplusNonResident.priceMember">
              {{ _class.surplusNonResident.priceMember | money }} en sus des frais
              membre si membre du COQ.
            </li>
            <li v-if="_class.surplusNonResidentMinor">
              Jeunes :
              {{ _class.surplusNonResidentMinor.priceRegular | money }} en sus des
              frais réguliers.
            </li>
            <li v-if="_class.surplusNonResidentMinor && _class.surplusNonResidentMinor.priceMember">
              Jeunes : {{ _class.surplusNonResidentMinor.priceMember | money }} en
              sus des frais membre si membre du COQ.
            </li>
            <li>(Pour usage des locaux et équipements de la Ville)</li>
          </ul>
        </li>
      </ul>

      <table
          :id="'details_' + _class.category"
          :class="['class__description__' + _class.category]"
          v-if="_class.type !== 'Cours d\'initiation'"
          class="class__table"
      >
        <tr v-if="_class.maximumInscriptions && _class.maximumInscriptions > 0">
          <td class="gras">Contingentement&nbsp;:&nbsp;</td>
          <td>
            Le groupe du cours est limité normalement à
            {{ _class.maximumInscriptions }} inscriptions.
          </td>
        </tr>
        <tr v-if="_class.inscriptionLimit">
          <td class="gras" style="min-width: 100px;">
            Échéance :
          </td>
          <td>
            <span>La date de tombée pour les inscriptions est le
              {{ _class.inscriptionLimit | formatDate }}.
            </span>
          </td>
        </tr>
        <tr v-if="_class.allowInscriptionsAfter">
          <td class="gras">
            Modalités d’inscription&nbsp;:&nbsp;
          </td>
          <td>
            <span>
              <span style="font-weight:bold;">
                Attention : les inscriptions commenceront le
                {{ _class.allowInscriptionsAfter | formatDateAndTime }}
              </span>
              (aucune inscription ne sera valide avant cette date).
            </span>
          </td>
        </tr>
      </table>
    </div>

    <div class="classBookButton">

      <template
          v-if="_classAcceptRegistrations(_class) && !_classIsFull(_class) && _classRegistrationPeriodIsNow(_class)">

        <button @click="bookClass" class="btn btn-primary" v-if="connected">
          Réserver ce cours
        </button>

        <b-button variant="outline-secondary" style="width: 100%; margin-top: 20px"
                  @click="$router.push({ name: 'DevenirMembrePage'});" v-else>
          Devenir membre
        </b-button>

      </template>

      <div v-else-if="_classIsFull(_class)">
        Cours complet
      </div>
      <div v-else-if="!_classRegistrationPeriodIsNow(_class)">
        Inscriptions désactivées pour le moment ou la période d'inscription est terminée.
      </div>
      <div v-else>Inscriptions fermées</div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import 'moment-timezone';
  import { mapState } from 'vuex';

  import ClassRegistrationModal from './Cours_Inscription.vue';
  import CoursInscriptionMixin from '@/pages/Cours/CoursInscription.mixin';

  const colors = {
    niveau1: '#b1661b',
    niveau2: '#b1661b'
  };

  export default {
    name: 'class',
    props: {
      _class: Object
    },
    mixins: [
      CoursInscriptionMixin
    ],
    computed: {
      colorCode() {
        if (this._class.category in colors) {
          return colors[this._class.category];
        }
        return null;
      },
      ...mapState({
        connected: state => state.account.status.loggedIn
      }),
      limitDateInPeriod() {
        const now = moment();
        if (this._class.allowInscriptionsAfter) {
          const allowAfter = moment
            .tz(this._class.allowInscriptionsAfter, 'UTC')
            .tz('America/New_York');
          const inscriptionLimit = moment
            .tz(this._class.inscriptionLimit, 'UTC')
            .tz('America/New_York');
          return now.isBefore(inscriptionLimit) && now.isSameOrAfter(allowAfter);
        }
        else {
          const inscriptionLimit = moment
            .tz(this._class.inscriptionLimit, 'UTC')
            .tz('America/New_York');
          return now.isBefore(inscriptionLimit);
        }
      }
    },
    methods: {
      async bookClass() {
        // Ask the user to confirm and select the member to be registered.
        await this.$store.dispatch('members/fetchMembers');
        // Show modal
        this.$modal.show(ClassRegistrationModal, {
          classId: this._class.id
        }, {
          height: 'auto',
          name: 'class-registration-modal',
          root: this.$root
        });
      }
    },
    filters: {
      classNameFormatter(name) {
        switch (name) {
          case 'niveau1':
            return 'Niveau 1';
          case 'niveau2':
            return 'Niveau 2';
          case 'limicoles':
            return 'Limicoles';
          case 'parulines':
            return 'Parulines';
          case 'larides':
            return 'Laridés';
          case 'bruants':
            return 'Bruants';
          case 'rapaces':
            return 'Rapaces';
          case 'parulines_automne':
            return 'Parulines d\'automne';
          case 'migration':
            return 'Migration';
        }
      }
    }
  };
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css2?family=PT+Sans:wght@400;700&display=swap');
@import '../../stylesheets/colors';

.class {
  margin-top: 80px;
  margin-bottom: 20px;

  table {
    width: 100%;
  }

  h1 {
    font-size: 1rem;
  }

  h2 {
    font-size: 0.8rem;
  }

  h3 {
    font-size: 0.6rem;
    margin: 2rem 0;
  }

  h4 {
    font-size: 0.4rem;
  }

  h5 {
    font-size: 0.2rem;
  }

  p {
    margin: 0;
    padding: 10px 0;
    text-align: justify;
    width: 100%;
  }

  &__description {
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;

    ul li {
      margin: 0 !important;

      p {
        padding: 0 !important;
        margin-bottom: 0 !important;
      }
    }

    &__parulines {
      background: lighten($class-parulines, 40);
    }
    &__larides {
      background: lighten($class-larides, 40);
    }
    &__bruants {
      background: lighten($class-bruants, 30);
    }
    &__rapaces {
      background: lighten($class-rapaces, 33);
    }
    &__parulines_automne {
      background: lighten($class-parulines, 40);
    }
    &__niveau1 {
      background: lighten($class-niveau1, 30);
    }
    &__niveau2, &__limicoles  {
      background: lighten($class-niveau2, 50);
    }
    &__migration {
      background: lighten($class-migration, 42);
    }

    &__title {
      font-family: 'PT Sans', sans-serif;
      -webkit-text-stroke: 1px #c0b5dc;
      font-weight: 600;
      font-size: 60px;
      position: relative;
      top: -12px;

      &__parulines {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(darken($class-parulines, 5)));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &__larides {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(darken($class-larides, 5)));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &__bruants {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#7900c9));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &__rapaces {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#007cc9));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &__parulines_automne {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#c98900));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &__niveau1 {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#00c9c9));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &__niveau2, &__limicoles  {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#04c900));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &__migration {
        background: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#c94d00));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    &__text {
      padding: 5px 20px 20px;
      text-transform: math-auto;
    }
  }

  &__information {
    padding: 10px 30px;

    &__parulines {
      background: lighten($class-parulines, 48);
    }
    &__larides {
      background: lighten($class-larides, 42);
    }
    &__bruants {
      background: lighten($class-bruants, 35);
    }
    &__rapaces {
      background: lighten($class-rapaces, 36);
    }
    &__parulines_automne {
      background: lighten($class-parulines, 50);
    }
    &__niveau1 {
      background: lighten($class-niveau1, 35);
    }
    &__niveau2, &__limicoles  {
      background: lighten($class-niveau2, 58);
    }
    &__migration {
      background: lighten($class-migration, 45);
    }
  }

  .subtitle {
    font-weight: bold;
    color: #b1661b;
  }

  &__structure {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;

    ul,
    li {
      margin: 0;
      padding: 0;
    }
  }

  &__table {
    //margin-top: 20px;

    tr {
      td {
        padding: 15px;
      }
    }
  }

  .description {
    p {
      margin-left: 0;
      padding: 5px 2rem;
      width: 100%;
    }

    ul {
      margin-left: 0;
      padding: 5px 3rem;
      width: 100%;
    }

    :last-child {
      padding-bottom: 10px;
    }
  }

  .details_bruants {
    text-align: left !important;
  }
}

.classBookButton {
  text-align: center;
  margin-top: 25px;
  margin-bottom: 25px;
}

.gras {
  font-weight: bold;
}

</style>
